import getTodoRequestHeaders from '../utils/getTodoRequestHeaders';
import { toTodoFolder } from '../utils/toTodoFolder';
import { TODO_API_GET_LISTS } from '../utils/constants';
import type { TodoFolder } from 'owa-todo-types';
import { makeGetRequest } from 'owa-ows-gateway';

/**
 * Calls makeGetRequest to fetch all the task folders.
 */
export default function getTaskFoldersService(): Promise<TodoFolder[] | null> {
    return makeGetRequest(
        TODO_API_GET_LISTS,
        undefined /* correlationId */,
        false /* returnFullResponse */,
        getTodoRequestHeaders() /* customHeaders */
    )
        .then((response: any) => {
            if (response?.Value) {
                return response.Value.map(folder => toTodoFolder(folder));
            }

            return null;
        })
        .catch(err => {
            return null;
        });
}
